<template>

    <Head title="MFA" />
    <RegisterLayout title="Multiplo Fator de Autenticação">
      <article class="xl:max-w-[352px] mx-auto">
        <div class="sm:px-5 xl:max-w-full">
          <p class="pb-4 text-white">Para mantermos sua conta segura, precisamos garantir que é realmente você tentando
            acessar a conta:</p>

          <div class="text-white" v-if="$page.props.flash.error">
            {{ $page.props.flash.error }}
          </div>

          <div class="text-white" v-if="$page.props.flash.success">
            {{ $page.props.flash.success }}
          </div>
        </div>

      </article>
      <MFAModal v-if="true" :credentialauthenticationmethods="credential.credentialauthenticationmethods"
        :accessTo="authorizeModal.accessTo" :showModal="true"
        @onCancel="cancelAuthorizationModalEvent"
        @onSuccess="successAuthorizationModalEvent"
        :guest="true" />
    </RegisterLayout>
  </template>

  <script>
  import Input from '@/Components/UI/Form/Input.vue';
  import Icon from '@/Components/UI/Icons/Icon.vue'
  import Button from '@/Components/Button.vue'
  import RegisterLayout from "@/Layouts/Register.vue";
  import Header from '@/Components/UI/Nav/Header.vue'
  import Back from '@/Components/UI/Back.vue'
  import { Head, Link } from "@inertiajs/inertia-vue3";
  import HeadingGuest from "@/Components/UI/Texts/HeadingGuest.vue"
  import MFAModal from "@/Components/MFA/Modal.vue";
  import getBrowserFingerprint from "get-browser-fingerprint";

  export default {
    components: {
      Header,
      Head,
      Input,
      Icon,
      Button,
      Link,
      Back,
      RegisterLayout,
      HeadingGuest,
      MFAModal,
    },
    props: {
      authenticationMethods: Object,
      credential: Object,
      redirect: String,
      defaultContact: String,
    },
    data() {
      return {
        showSuccessModal: false,
        isAuthorizeModalOpen: false,
        defaultAuthorizeModal: {
          defaultCredentialAuthorizationId: '',
          defaultCredentialAuthenticationMethodId: '',
          accessTo: 'activation',
          defaultContact: this.defaultContact,
        },
        authorizeModal: {
          defaultCredentialAuthorizationId: '',
          defaultCredentialAuthenticationMethodId: '',
          accessTo: 'activation',
          defaultContact: this.defaultContact,
        },
        createdCredentialAuthenticationMethodId: '',
        createdCredentialAuthorizationId: '',
        confirmPassword: "",
        form: this.$inertia.form({
          contact: this.defaultContact,
        }),
      }
    },
    mounted() {
      this.mount();
    },
    methods: {
      mount() {
        this.resetAuthorizationModalObject();
      },
      resetAuthorizationModalObject() {
        this.authorizeModal = this.defaultAuthorizeModal;
      },
      closeAuthorizationModal() {
        this.isAuthorizeModalOpen = false;
      },
      openAuthorizationModal() {
        this.isAuthorizeModalOpen = true;
      },
      cancelAuthorizationModalEvent() {
        this.closeAuthorizationModal();
        this.resetAuthorizationModalObject();
      },
      successAuthorizationModalEvent() {
        this.closeAuthorizationModal();
        this.resetAuthorizationModalObject();
        this.$inertia.get(this.route(this.redirect || 'register.success'));
      },
      submit() {
        if (this.form.contact && this.form.contact.trim() !== "") {
          axios
            .post(this.route("mfa.create-authenticationmethod"), {
              authenticationmethodId: this.emailAuthenticationMethod.authenticationmethod?.id,
              contact: this.form.contact.trim(),
              fingerprintHash: this.browserFingerprint,
            })
            .then(({ data }) => {
              const error = data.error;
              this.$page.props.flash.error = '';

              if (error) {
                const errorMessage = data.data.message;
                this.$page.props.flash.error = errorMessage;
              } else {
                this.openAuthorizationModal();
                this.authorizeModal.defaultCredentialAuthenticationMethodId = data.id;
                this.authorizeModal.defaultCredentialAuthorizationId = data.credentialauthorizationId;
                this.authorizeModal.defaultContact = data.contact;
              }
            })
            .catch(function (error) {
              console.log("Erro:", error);
            });
        }
      },
    },
    computed: {
      allIsValid() {
        return this.form.contact && this.form.contact.trim() !== "";
      },
      browserFingerprint() {
        return getBrowserFingerprint();
      },
      isEnabled() {
        return this.authenticationMethods?.length > 0 && this.credential?.id;
      },
      emailAuthenticationMethod() {
        return this.authenticationMethods?.find(({ authenticationmethod }) => authenticationmethod?.name?.toUpperCase() === 'EMAIL');
      },
    }
  }
  </script>
